import { NetClient } from "../../net/net_client";
import Module from "./module_base";
import GameUtil from "../../../utility/game_util";
import LogManager from "../../../manager/log_manager";
import AppData from '../../../pacakge/public/const/app_data';

export default class ModelBase {

    module: Module<any, any>
    private netClient: NetClient
    private _msgEventMap = {}

    public isDestroyed = false

    private _MsgLogJSONStringifySpace = 1

    private _logFilter: (msgName: string, data : any) => boolean;

    constructor() {
        if (CC_JSB) {
            this._MsgLogJSONStringifySpace = null
        }
    }

    public init(netClient: NetClient) {
        this.netClient = netClient
        if (CC_JSB) {
            this._MsgLogJSONStringifySpace = null
        }
        switch (this.netClient.name) {
            case "HallServer":
            case "GameServer":
                this._logFilter = this._logFilterHallGameServer
                break;
            case "HallServerNotify":
                this._logFilter = this._logFilterHallServerNotify
                break;
            case "ClubHallServer":
                this._logFilter = this._logFilterClubHallServerNotify
                break;     
            case "NotifyServer":
                this._MsgLogJSONStringifySpace = null
                this._logFilter = this._logFilterApiNotifyServer
                break;
            default:
                break;
        }
    }

    private bufferType1(msgDataMap, dataBuffer) {   //messageName(4字节)|dataSzie(4字节)| protoData真正的数据
        var requestBuffer = new ArrayBuffer(8 + dataBuffer.length);
        let int32Array = new Int32Array(requestBuffer, 0, 2);
        int32Array[0] = msgDataMap[0];
        int32Array[1] = dataBuffer.length

        let uint8Array = new Uint8Array(requestBuffer, 8, dataBuffer.length)
        uint8Array.set(dataBuffer);

        return requestBuffer
    }

    private bufferType(dataBuffer) {   //protoData真正的数据
        var requestBuffer = new ArrayBuffer(dataBuffer.length);
        let uint8Array = new Uint8Array(requestBuffer, 0, dataBuffer.length)
        uint8Array.set(dataBuffer);
        return requestBuffer
    }

    // 包头的长度是动态 总长度(2字节)|Pbc的MessageName长度(2字节)|Pbc的MessageName真正数据(动态长度)|Pbc的MessageData长度(2字节)|Pbc的MessageData真正数据(动态长度)
    private bufferType3(msgDataMap, dataBuffer: Uint8Array) {
        let msgNameLen = GameUtil.stringBytesLength(msgDataMap[0].toString())
        var requestBuffer = new ArrayBuffer(6 + msgNameLen + dataBuffer.length);
        let dv = new DataView(requestBuffer)
        dv.setInt16(0, 4 + msgNameLen + dataBuffer.length, false)
        dv.setInt16(2, msgNameLen, false)
        let uint8Array1 = new Uint8Array(requestBuffer, 4, msgNameLen)
        uint8Array1.set(GameUtil.str2UTF8Byte(msgDataMap[0].toString()));
        dv.setInt16(4 + msgNameLen, dataBuffer.length, false)
        let uint8Array2 = new Uint8Array(requestBuffer, 6 + msgNameLen)
        uint8Array2.set(dataBuffer);
        return requestBuffer
    }

    _logFilterHallGameServer( msgName, data) {
        if (msgName == "Login.PingReq" || msgName == "Login.PingRsp" || msgName == 5) {
            return
        }
        return true
    }

    _logFilterHallServerNotify(msgName, data) {
        
        if (!AppData.testMode || msgName == "Hall.PingReq" || msgName == "Hall.PingRsp" || msgName == "Hall.NotifyHallData") {
            return
        }
        return true
    }

    _logFilterClubHallServerNotify(msgName, data) {
        
        if (!AppData.testMode || msgName == "Hallx.IdlePingReq" || msgName == "Hallx.IdlePingRsp" ) {
            return
        }
        return true
    }

    _logFilterApiNotifyServer(msgName, data) {        
        if (AppData.testMode) {
            if (data && (data.type == 0 || data.type == 1)) {
                return false
            }
        } else {
            if (data && (data.type == 0 || data.type == 1 || data.type == 2 || data.type == 3 || data.type == 102)) {
                return
            }
        }
        return true
    }

    sendMsg(msgDataMap, data) {
        let dataBuffer: Uint8Array = msgDataMap[1].encode(data).finish();
        let requestBuffer: ArrayBuffer
        if (msgDataMap[4] == 1) {   //协议1
            requestBuffer = this.bufferType1(msgDataMap, dataBuffer)
        }
        else if (msgDataMap[4] == 2) {  //c++游戏服
        }
        else if (msgDataMap[4] == 3) {   //lua游戏服
            requestBuffer = this.bufferType3(msgDataMap, dataBuffer)
        } else if (msgDataMap[4] == 4) { //通知服 运营后台推送
            requestBuffer = this.bufferType(dataBuffer)
        }
        let msgName = msgDataMap[0]
        this.netClient.send(requestBuffer)
        let show = this._logFilter(msgName, data)
        if (show) {
            let text = `【${this.netClient.name}】 send: ${msgName}  ${JSON.stringify(data, null, this._MsgLogJSONStringifySpace)}`
            cc.log(text)
            CC_JSB && LogManager.instance.log(text)
        }
    }

    subscibeMsgEvent<T>(mapData: any[], callback: (protoData: T) => void, ignoreModuleActive: boolean = false) {
        let self = this;
        let msgName = mapData[2]
        let cb = function (receiveMessageData) {
            let data = mapData[3].decode(receiveMessageData);
            try { //万一写日志出错了，也不会阻塞正常逻辑
                let show = self._logFilter(msgName, data)
                if (show) {
                    let text = `【${self.netClient.name}】 rec: ${msgName}  ${JSON.stringify(data, null, self._MsgLogJSONStringifySpace)}`
                    cc.log(text)
                    CC_JSB && LogManager.instance.log(text)
                }
            } catch (error) { }
            if (callback) {
                if (ignoreModuleActive) {
                    callback(data)
                } else {
                    if (!self.isDestroyed) {
                        callback(data)
                    }
                }
            }
        }
        let eventDataList = this._msgEventMap[msgName]
        if (!eventDataList) {
            eventDataList = []
            this._msgEventMap[msgName] = eventDataList
        }
        let eventData = {
            msgName: msgName,
            callback: cb,
        }

        eventDataList.push(eventData)
        this.netClient.subscibeMsgEvent(msgName, cb, null)
    }


    clearMsgEvent() {
        for (const key in this._msgEventMap) {
            if (this._msgEventMap.hasOwnProperty(key)) {
                const element = this._msgEventMap[key];
                for (let index = 0; index < element.length; index++) {
                    const e = element[index];
                    this.netClient.unsubscibeMsgEvent(e.msgName, e.callback, null)
                }
            }
        }
        this._msgEventMap = {}
    }

    //需要注意网络是有延时的，如果界面隐藏了需要是否过滤掉处理
    http_get(requestData: any, responeSuccessCallback: any, responeErrorCallback: any) {
        if (this.module) {
            this.module.apiHttpGet(requestData, responeSuccessCallback, responeErrorCallback)
        }
    }

    destroyModel() {
        this.isDestroyed = true
        this.clearMsgEvent()
    }

    disconnect() {
        this.netClient.disconnect()
    }

}
